const PhoneSubLabelInput = ({ value, onChange, readOnly }) => (
    <input
      placeholder="یک SubLabel وارد کنید"
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: 1.45,
        color: '#b8bdc9',
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
  );
  
  export default PhoneSubLabelInput;
  